<template>
  <div class="full-screen" style="z-index: 10;background:#fff;">
    <header class="aui-navBar aui-navBar-fixed b-line">
      <a @click="returnPage" class="aui-navBar-item">
        <i class="icon icon-return"></i>
      </a>
      <div class="aui-center">
        <span class="aui-center-title">更换账号</span>
      </div>
      <a @click="returnHome" class="aui-navBar-item">
        <i class="icon icon-sys"></i>
      </a>
    </header>
    <section class="aui-scrollView no-foot">
      <p v-if="errorMsg.show" class="error-info">{{errorMsg.msg}}</p>
      <div class="login">
        <ul class="login-form">
          <li>
            <i class="ico-user"></i>
            <input type="text" v-model="account"   placeholder="请输入登录账号" />
          </li>
          <li>
            <i class="ico-password"></i>
            <input type="text" v-model="password" placeholder="请输入登录密码" />
          </li>
        </ul>
        <button type="button" @click="validate"  class="login-btn">登 录</button>
      </div>
    </section>
    <!-- <div class="login">
      <h2>
        <img src="../../../assets/img/logo.png" />
      </h2>
      <ul>
        <li>
          <label>手机号码</label>
          <div>
            <input class="inp" type="text" placeholder="请输入登录手机号" />
          </div>
        </li>
        <li>
          <label>密码</label>
          <div>
            <input  class="inp" type="password" placeholder="请输入密码" />
          </div>
        </li>
      </ul>

      <div v-if="errorMsg.show" class="text-red">{{errorMsg.msg}}</div>
      <div class="btnbox">
        <button type="button" class="btn" >登录</button>
      </div>
    </div> -->

    <div id="confirm-modal" v-if="showModal" class="fixed-confirm" style="display: block;">
      <div class="fixed-c">
        <h3>登录成功</h3>
        <div class="btnbox">
          <button class="btn" type="button" @click="hideModal">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '../../../services/userService'

export default {
  name: 'login',
  data () {
    return {
      account: '',
      password: '',
      errorMsg: {
        show: false,
        msg: ''
      },
      showModal: false
    }
  },
  methods: {
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    returnHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    },
    validate () {
      if (this.account === '') {
        this.errorMsg = { show: true, msg: '请输入手机号' }
      } else if (this.password === '') {
        this.errorMsg = { show: true, msg: '请输入密码' }
      } else {
        this.login()
      }
    },
    login () {
      userService.login(this.account, this.password).then(res => {
        if (res.result) {
          this.showModal = true
        } else {
          this.errorMsg = { show: true, msg: '账户或密码不正确' }
        }
      })
    },
    hideModal () {
      const obj = document.getElementById('confirm-modal')
      obj.style.opacity = 1
      this.slideOut(obj)
    },
    slideOut (obj) {
      obj.style.opacity -= 0.05
      if (obj.style.opacity > 0) {
        setTimeout(() => {
          this.slideOut(obj)
        }, 15)
      } else {
        this.showModal = false
        this.$router.isBack = false
        this.$router.push('/user')
      }
    }
  },
  mounted () {
    this.$router.isBack = true
  }
}
</script>

<style scoped>
</style>
